export const PAYMENT_UI_PAGE = '/paymentui';
export const QUICK_INVOICE_PAGE = `${PAYMENT_UI_PAGE}/quickinvoice`;
export const PAYMENT_STATUS_PAGE = `${PAYMENT_UI_PAGE}/payment-status`;
